<!-- eslint-disable max-len -->
<template>
  <div class="d-flex flex-column">
    <!-- Screen Mode & Save -->
    <div
      :class="{ 'screen-mode-and-save-scroll': isScroll }"
      class="screen-mode-and-save justify-content-end"
    >
      <div class="wrap-screen-mode justify-content-end">
        <button
          class="save-button"
          @click="submitForm">
          Save
        </button>
      </div>
    </div>

    <!-- Card General Information -->
    <div class="card-page">
      <div class="card-page-content input-field">
        <h6 class="card-title-text">General Information</h6>

        <b-form-group :class="{'error-input' : $v.dataSetup.name.$error}">
          <label>Title</label>
          <j-input
            v-model="$v.dataSetup.name.$model"
            placeholder="Title"/>
        </b-form-group>
        <b-form-group :class="{'error-input' : $v.dataSetup.source.$error}">
          <label>Source</label>
          <j-single-select
            v-model="$v.dataSetup.source.$model"
            :options="sourceOptions"
            :placeholder="'Select Source'"
            value-format="object"
            label="label"/>
        </b-form-group>
        <b-form-group
          v-if="sourceIsForm"
          :class="{'error-input' : $v.dataSetup.table_group.$error}">
          <label> Table Group </label>
          <j-single-select
            v-model="$v.dataSetup.table_group.$model"
            :options="tableGroupOptions"
            placeholder="Select Table Group"
            value-format="object"
            label="name"/>
        </b-form-group>
        <b-form-group
          v-if="sourceIsForm"
          :class="{'error-input' : $v.dataSetup.form.$error}">
          <label> Table </label>
          <j-single-select
            v-model="$v.dataSetup.form.$model"
            :disabled="!dataSetup.table_group"
            :options="tableOptions"
            :placeholder="'Select Table'"
            value-format="object"
            label="name"/>
        </b-form-group>
        <b-form-group
          v-if="sourceIsDataset"
          :class="{'error-input' : $v.dataSetup.dataset_group.$error}">
          <label> Dataset Group </label>
          <j-single-select
            v-model="$v.dataSetup.dataset_group.$model"
            :options="datasetGroupOptions"
            placeholder="Select Dataset Group"
            value-format="object"
            label="name"/>
        </b-form-group>
        <b-form-group
          v-if="sourceIsDataset"
          :class="{'error-input' : $v.dataSetup.dataset.$error}">
          <label> Dataset </label>
          <j-single-select
            v-model="$v.dataSetup.dataset.$model"
            :disabled="!dataSetup.dataset_group"
            :options="datasetOptions"
            placeholder="Select Dataset"
            value-format="object"
            label="name"/>
        </b-form-group>
      </div>
    </div>

    <!-- Card Variable -->
    <div
      v-if="sourceIsApi"
      class="card-page m__t--25">
      <div class="card-page-content input-field">
        <h6 class="card-title-text">Variable</h6>

        <section>
          <div
            v-for="(data, index) in dataSetup.column"
            :key="index"
            class="field-list mb-2">
            <b-row>
              <b-col
                cols="5"
                lg="5">
                <b-form>
                  <label> Name </label>
                  <j-input
                    v-model="data.name"
                    :error-required="false"
                    placeholder="Enter name here"/>
                </b-form>
              </b-col>
              <b-col
                cols="4"
                lg="4">
                <b-form>
                  <label> Data Type </label>
                  <j-single-select
                    v-model="data.type"
                    :options="dataTypeOptions"
                    :placeholder="'Select Data Type'"
                    :error-required="false"/>
                </b-form>
              </b-col>
              <b-col
                cols="2"
                lg="2">
                <b-form>
                  <label> Set Primary Key </label>
                  <j-switch
                    v-model="data.is_primary_key"
                    @input="cekPrimaryAvail(index)"
                  />
                </b-form>
              </b-col>
              <b-col
                cols="1"
                lg="1"
                class="d-flex align-items-center justify-content-center cursor-pointer">
                <i
                  class="fa fa-lg fa-trash"
                  @click="deleteColumn(index)"/>
              </b-col>
            </b-row>
          </div>
        </section>

        <div
          class="btn-add__experience-manager m__b--20"
          @click="addColumn">
          <img
            :src="require('@/assets/icon/add.png')"
            class="m__r--5"
            height="15"
            width="15">
          Add Variable
        </div>

        <div v-if="formDetail.data_source && formDetail.data_source.external_url">
          <h6 class="card-title-text">API</h6>
          <b-row>
            <b-col md="6">
              <div class="wrap-external-api">
                <h4>List Data</h4>

                <div class="div-external-api">
                  <div class="icon-ext-api">
                    <img src="@/assets/new-form-ui/ext-api.svg">
                  </div>

                  <div class="ext-api-desc">
                    <div class="ext-api-url">
                      <span
                        v-if="formDetail.data_source.external_url.list.method"
                        class="method"
                      >
                        {{ formDetail.data_source.external_url.list.method }}
                      </span>
                      {{ formDetail.data_source.external_url.list.url ? formDetail.data_source.external_url.list.url : 'API Not Configure' }}
                    </div>
                    <div
                      class="edit-btn"
                      @click="openExternalUrlConfig('list')"
                    >
                      Edit
                    </div>
                  </div>
                </div>
              </div>
              <div class="wrap-external-api">
                <h4>Create Data</h4>

                <div class="div-external-api">
                  <div class="icon-ext-api">
                    <img src="@/assets/new-form-ui/ext-api.svg">
                  </div>

                  <div class="ext-api-desc">
                    <div class="ext-api-url">
                      <span
                        v-if="formDetail.data_source.external_url.create.method"
                        class="method"
                      >
                        {{ formDetail.data_source.external_url.create.method }}
                      </span>
                      {{ formDetail.data_source.external_url.create.url ? formDetail.data_source.external_url.create.url : 'API Not Configure' }}
                    </div>
                    <div
                      class="edit-btn"
                      @click="openExternalUrlConfig('create')"
                    >
                      Edit
                    </div>
                  </div>
                </div>
              </div>
              <div class="wrap-external-api">
                <h4>Delete Data</h4>

                <div class="div-external-api">
                  <div class="icon-ext-api">
                    <img src="@/assets/new-form-ui/ext-api.svg">
                  </div>

                  <div class="ext-api-desc">
                    <div class="ext-api-url">
                      <span
                        v-if="formDetail.data_source.external_url.delete.method"
                        class="method"
                      >
                        {{ formDetail.data_source.external_url.delete.method }}
                      </span>
                      {{ formDetail.data_source.external_url.delete.url ? formDetail.data_source.external_url.delete.url : 'API Not Configure' }}
                    </div>
                    <div
                      class="edit-btn"
                      @click="openExternalUrlConfig('delete')"
                    >
                      Edit
                    </div>
                  </div>
                </div>
              </div>
              <div class="wrap-external-api">
                <h4>Export Data</h4>

                <div class="div-external-api">
                  <div class="icon-ext-api">
                    <img src="@/assets/new-form-ui/ext-api.svg">
                  </div>

                  <div class="ext-api-desc">
                    <div class="ext-api-url">
                      <span
                        v-if="formDetail.data_source.external_url.export.method"
                        class="method"
                      >
                        {{ formDetail.data_source.external_url.export.method }}
                      </span>
                      {{ formDetail.data_source.external_url.export.url ? formDetail.data_source.external_url.export.url : 'API Not Configure' }}
                    </div>
                    <div
                      class="edit-btn"
                      @click="openExternalUrlConfig('export')"
                    >
                      Edit
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
            <b-col md="6">
              <div class="wrap-external-api">
                <h4>Detail Data</h4>

                <div class="div-external-api">
                  <div class="icon-ext-api">
                    <img src="@/assets/new-form-ui/ext-api.svg">
                  </div>

                  <div class="ext-api-desc">
                    <div class="ext-api-url">
                      <span
                        v-if="formDetail.data_source.external_url.detail.method"
                        class="method"
                      >
                        {{ formDetail.data_source.external_url.detail.method }}
                      </span>
                      {{ formDetail.data_source.external_url.detail.url ? formDetail.data_source.external_url.detail.url : 'API Not Configure' }}
                    </div>
                    <div
                      class="edit-btn"
                      @click="openExternalUrlConfig('detail')"
                    >
                      Edit
                    </div>
                  </div>
                </div>
              </div>
              <div class="wrap-external-api">
                <h4>Update Data</h4>

                <div class="div-external-api">
                  <div class="icon-ext-api">
                    <img src="@/assets/new-form-ui/ext-api.svg">
                  </div>

                  <div class="ext-api-desc">
                    <div class="ext-api-url">
                      <span
                        v-if="formDetail.data_source.external_url.update.method"
                        class="method"
                      >
                        {{ formDetail.data_source.external_url.update.method }}
                      </span>
                      {{ formDetail.data_source.external_url.update.url ? formDetail.data_source.external_url.update.url : 'API Not Configure' }}
                    </div>
                    <div
                      class="edit-btn"
                      @click="openExternalUrlConfig('update')"
                    >
                      Edit
                    </div>
                  </div>
                </div>
              </div>
              <div class="wrap-external-api">
                <h4>Import Data</h4>

                <div class="div-external-api">
                  <div class="icon-ext-api">
                    <img src="@/assets/new-form-ui/ext-api.svg">
                  </div>

                  <div class="ext-api-desc">
                    <div class="ext-api-url">
                      <span
                        v-if="formDetail.data_source.external_url.import.method"
                        class="method"
                      >
                        {{ formDetail.data_source.external_url.import.method }}
                      </span>
                      {{ formDetail.data_source.external_url.import.url ? formDetail.data_source.external_url.import.url : 'API Not Configure' }}
                    </div>
                    <div
                      class="edit-btn"
                      @click="openExternalUrlConfig('import')"
                    >
                      Edit
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>

    <!-- Card Digital Signature -->
    <div
      v-if="!sourceIsDataset"
      class="card-page m__t--25">
      <div class="card-page-content input-field general-info">
        <div class="d-flex justify-content-between">
          <h6 class="card-title-text m-0">Digital Signature</h6>

          <b-form-group>
            <j-switch v-model="dataSetup.isUseDigitalSignature"/>
          </b-form-group>
        </div>

        <b-form-group
          v-if="dataSetup.isUseDigitalSignature"
          :class="{'error-input' : $v.dataSetup.thirdPartyConn.$error}">
          <label>Third Party</label>
          <j-single-select
            v-model="$v.dataSetup.thirdPartyConn.$model"
            :options="listThirdParty"
            placeholder="Select Third Party"
            value-format="object"
            label="label"/>
        </b-form-group>

        <b-form-group
          v-if="dataSetup.isUseDigitalSignature"
          :class="{'error-input' : $v.dataSetup.attachSigned.$error}">
          <label>Attach signed document</label>
          <j-single-select
            v-model="$v.dataSetup.attachSigned.$model"
            :options="columnOptions"
            placeholder="Select Column"
            value-format="object"
            label="label"/>
        </b-form-group>

        <b-form-group
          v-if="dataSetup.isUseDigitalSignature"
          :class="{'error-input' : $v.dataSetup.attachNotSigned.$error}">
          <label>Attach not signed document</label>
          <j-single-select
            v-model="$v.dataSetup.attachNotSigned.$model"
            :options="columnOptions"
            placeholder="Select Column"
            value-format="object"
            label="label"/>
        </b-form-group>
      </div>
    </div>

    <!-- Config External URL -->
    <external-api-form
      v-if="sourceIsApi && isOpenExternalApiConfig"
      ref="externalApiConfig"
      :id="'externalApiConfig'"
      :type-tab="typeTab"
      :list-variable="dataSetup.column"
      :is-multiple-form="isMultipleForm"
      @close-config="toggleExternalApiConfig(false)" />
  </div>
</template>

<script>
/* eslint-disable max-len, no-nested-ternary, no-console, camelcase, func-names, no-unused-vars */
import { required } from 'vuelidate/lib/validators';
import { mapActions, mapState, mapMutations } from 'vuex';
import ExternalApiForm from '@/views/experience-manager-v2/partials/ExternalApiForm';
import jSwitch from '@/components/inputs/jSwitch';
import jwtDecode from 'jwt-decode';
import draggable from 'vuedraggable';
import jMixAutoScroll from '@/mixins/jMixAutoScroll';
import jMixScroll from '@/mixins/form-ui-v2/jMixScroll';

export default {
  components: {
    draggable,
    ExternalApiForm,
    jSwitch,
  },

  mixins: [jMixAutoScroll, jMixScroll],

  props: {
    formDetail: {
      type: Object,
      default: () => {},
    },
    formData: {
      type: Object,
      default: () => {},
    },
    isMultipleForm: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isLoading: true,
      dataSetup: {
        name: null,
        source: null,
        form: null,
        external_url: null,
        column: [],
        isUseDigitalSignature: false,
        thirdPartyConn: null,
        attachSigned: null,
        attachNotSigned: null,
        dataset_group: null,
        dataset: null,
        table_group: null,
      },
      typeTab: '',
      isOpenExternalApiConfig: false,
      sourceOptions: [
        {
          id: 'form',
          label: 'Data Manager',
          text: 'Data Manager',
        },
        {
          id: 'external_url',
          label: 'External API',
          text: 'External API',
        },
      ],
      dataTypeOptions: [
        {
          id: 'text',
          text: 'Text',
        },
        {
          id: 'number',
          text: 'Number',
        },
        {
          id: '[]text',
          text: 'Array Of Text',
        },
        {
          id: '[]number',
          text: 'Array Of Number',
        },
        {
          id: 'boolean',
          text: 'Boolean',
        },
        {
          id: 'timestamp',
          text: 'Timestamp',
        },
        {
          id: 'person',
          text: 'Person',
        },
        {
          id: 'object',
          text: 'Object',
        },
        {
          id: 'maps',
          text: 'Maps',
        },
        {
          id: 'timer',
          text: 'Timer',
        },
        {
          id: '[]attachment',
          text: 'Array Of Attachment',
        },
        {
          id: '[]object',
          text: 'Array Of Object',
        },
        {
          id: 'tags',
          text: 'Tags',
        },
        {
          id: '[]tags',
          text: 'Array Of Tags',
        },
      ],
      columnOptions: [],
      listThirdParty: [],
      datasetGroupOptions: [],
      datasetOptions: [],
      tableGroupOptions: [],
      tableOptions: [],
      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),
    };
  },

  computed: {
    ...mapState('jStoreFormUi', ['list_form_data']),
    ...mapState('jStoreThirdParty', ['list_connection']),

    sourceIsForm() {
      if (this.dataSetup.source) {
        if (this.dataSetup.source.id === 'form') {
          return true;
        }
      }
      return false;
    },
    sourceIsApi() {
      if (this.dataSetup.source) {
        if (this.dataSetup.source.id === 'external_url') {
          return true;
        }
      }
      return false;
    },
    sourceIsDataset() {
      if (this.dataSetup.source) {
        if (this.dataSetup.source.id === 'dataset') {
          return true;
        }
      }
      return false;
    },
  },

  watch: {
    'dataSetup.source': function (val) {
      if (val.id === 'dataset') {
        this.dataSetup.dataset_group = this.formDetail.data_source.dataset && this.formDetail.data_source.dataset.dataset_group_id ?
          {
            id: this.formDetail.data_source.dataset.dataset_group_id || '',
            name: this.formDetail.data_source.dataset.dataset_group_name || '',
            label: this.formDetail.data_source.dataset.dataset_group_name || '',
          } :
          null;
        setTimeout(() => {
          this.dataSetup.dataset = this.formDetail.data_source.dataset && this.formDetail.data_source.dataset.dataset_id ?
            {
              id: this.formDetail.data_source.dataset.dataset_id || '',
              name: this.formDetail.data_source.dataset.dataset_name || '',
              label: this.formDetail.data_source.dataset.dataset_name || '',
            } :
            null;
        }, 500);
      }
    },
    'dataSetup.form': function (val) {
      this.columnOptions = [];

      const insertColumns = (listColumns) => {
        listColumns.forEach((column) => {
          this.columnOptions.push({
            id: column,
            label: column,
          });
        });
      };

      if (val) {
        if (val.columns) {
          insertColumns(Object.keys(val.columns));
        } else {
          const formData = this.list_form_data.filter(el => el.id === val.id);
          if (formData.length > 0) {
            insertColumns(Object.keys(formData[0].columns));
          }
        }
      }
    },
    list_connection(val) {
      this.listThirdParty = val.map(el => ({
        id: el.connection_name,
        label: el.connection_name,
      }));
    },
    'dataSetup.isUseDigitalSignature': function (val) {
      this.$v.dataSetup.$reset();
      if (!val) {
        this.dataSetup.thirdPartyConn = null;
        this.dataSetup.attachSigned = null;
        this.dataSetup.attachNotSigned = null;
      }
    },
    'dataSetup.dataset_group': function (val) {
      this.dataSetup.dataset = null;
      setTimeout(() => {
        this.$v.dataSetup.$reset();
      }, 500);
      if (val) {
        const reqData = {
          page: 1,
          limit: 100,
          filter: {
            where_is_and: { datasetgroup_id: val.id },
          },
          sort: { created_at: -1 },
          filter_operator: 'and',
        };
        this.getListDatasetByGroup(reqData).then((res) => {
          this.datasetOptions = res.data;
        });
      }
    },
    'dataSetup.table_group': function (val) {
      this.dataSetup.form = null;
      setTimeout(() => { this.$v.dataSetup.$reset(); }, 10);

      if (val) {
        const reqTable = {
          tablegroup_id: val.id,
          search: '',
        };
        this.getListTableByGroupV2(reqTable).then((res) => {
          if (!res.error) {
            this.tableOptions = res.data || [];
          }
        });
      }
    },
    'formDetail.name': function (val) {
      this.dataSetup.name = val;
    },
  },

  async created() {
    this.getListGroupTable();
    if (!this.isMultipleForm && process.env.BIG_DATA_ENGINE_MENU === 'true') {
      this.getListGroupDataset();
      this.sourceOptions.push({
        id: 'dataset',
        label: 'Dataset',
        text: 'Dataset',
      });
    }
    // const dataFilter = {
    //   company_id: this.session.user.company_id,
    // };
    // const param = {
    //   limit: 1000,
    //   page: 1,
    //   filter: JSON.stringify(dataFilter),
    // };
    // await this.actionGetFormDataList(param);
    const params = {
      limit: 50,
      page: 1,
      sort: { created_at: -1 },
    };
    await this.getListThirdPartyConnection(params);

    if (this.formDetail.type) {
      this.dataSetup.source = { id: this.formDetail.type };
    } else if (this.formDetail.form_data_id) {
      this.dataSetup.source = { id: 'form' };
    }
    const dataColumn = this.formDetail.data_source ?
      (this.formDetail.data_source.external_url ? this.formDetail.data_source.external_url.columns : null)
      : null;
    const dataPrimaryKey = this.formDetail.data_source ?
      (this.formDetail.data_source.external_url ? this.formDetail.data_source.external_url.primary_key : null)
      : null;
    if (this.formDetail.data_source) {
      if (this.formDetail.data_source.external_url) {
        this.formDetail.data_source.external_url.import = this.formDetail.data_source.external_url.import ? this.formDetail.data_source.external_url.import : {};
        this.formDetail.data_source.external_url.export = this.formDetail.data_source.external_url.export ? this.formDetail.data_source.external_url.export : {};
      }
    }
    if (dataColumn) {
      this.dataSetup.column = Object.values(dataColumn).map(e => ({
        name: e.name,
        type: e.type,
        is_primary_key: dataPrimaryKey === e.name,
      }));
    }

    this.dataSetup.name = this.formDetail.name || null;

    this.dataSetup.isUseDigitalSignature = this.formDetail.is_use_digital_signature;
    this.dataSetup.thirdPartyConn = this.formDetail.third_party_connection_name ? { id: this.formDetail.third_party_connection_name } : null;
    this.dataSetup.attachSigned = this.formDetail.attach_signed_document ? { id: this.formDetail.attach_signed_document } : null;
    this.dataSetup.attachNotSigned = this.formDetail.attach_not_signed_document ? { id: this.formDetail.attach_not_signed_document } : null;

    this.isLoading = false;
  },

  methods: {
    ...mapActions('jStoreFormUi', ['actionGetDetailForm', 'actionGetDetailMultiForm', 'actionSetForm', 'actionSetMultiForm', 'actionGetFormDataList', 'actionGetDetailFormData']),
    ...mapActions('jStoreThirdParty', ['getListThirdPartyConnection']),
    ...mapActions('jStoreJoana', ['getListDataGroup', 'getListDatasetByGroup']),
    ...mapActions('jStoreForm', ['getListDataGroupByCompanyId', 'getListTableByGroupV2']),
    ...mapMutations('jStoreFormUi', ['setChangesValueView']),

    addColumn() {
      this.dataSetup.column.push({
        name: null,
        type: null,
        is_primary_key: false,
      });
      this.setChangesValueView(true);
    },
    deleteColumn(index) {
      this.dataSetup.column.splice(index, 1);
      this.setChangesValueView(true);
    },
    openExternalUrlConfig(data) {
      if (this.isOpenExternalApiConfig) {
        this.toggleExternalApiConfig(false);
        setTimeout(() => {
          this.typeTab = data;
          this.isOpenExternalApiConfig = true;
          this.toggleExternalApiConfig(true);
        }, 250);
      } else {
        this.typeTab = data;
        this.isOpenExternalApiConfig = true;
        this.toggleExternalApiConfig(true);
      }
    },
    toggleExternalApiConfig(status) {
      if (status) {
        setTimeout(() => {
          const element = document.getElementById('externalApiConfig');
          if (element) element.classList.add('show-properties-field');
        }, 200);
      } else {
        const element = document.getElementById('externalApiConfig');
        if (element) element.classList.remove('show-properties-field');

        setTimeout(() => {
          this.isOpenExternalApiConfig = false;
        }, 200);
      }
    },
    cekPrimaryAvail(indexData) {
      this.dataSetup.column.forEach((e, index) => {
        if (index === indexData) {
          e.is_primary_key = true;
        } else {
          e.is_primary_key = false;
        }
      });
    },

    getListGroupDataset() {
      const req = {
        page: 1,
        limit: 1000000,
        sort: { updated_at: -1 },
        filter: null,
        filter_operator: 'and',
      };
      this.getListDataGroup(req).then((res) => {
        if (res.data) {
          this.datasetGroupOptions = res.data;
        }
      });
    },

    getListGroupTable() {
      this.getListDataGroupByCompanyId().then((res) => {
        if (!res.error) {
          this.tableGroupOptions = res.data || [];

          if (this.formDetail && this.formDetail.type === 'form') {
            const findTableGroup = res.data.find(f => f.id === this.formDetail.tablegroup_id);
            this.dataSetup.table_group = findTableGroup || null;

            if (!findTableGroup && this.formData) {
              if (this.formData.tablegroup_id) {
                const findTableGroupExist = res.data.find(f => f.id === this.formData.tablegroup_id);
                this.dataSetup.table_group = findTableGroupExist || null;
              } else {
                const findTableGroupLegacy = res.data.find(f => f.id === 'legacy');
                this.dataSetup.table_group = findTableGroupLegacy;
              }
            } else if (!findTableGroup && !this.formData) {
              const findTableGroupLegacy = res.data.find(f => f.id === 'legacy');
              this.dataSetup.table_group = findTableGroupLegacy;
            }

            setTimeout(() => { this.dataSetup.form = this.formData; }, 500);
          }
        }
      });
    },

    async submitForm() {
      this.$v.dataSetup.$touch();
      if (!this.$v.dataSetup.$error) {
        this.$swal({
          title: 'Update',
          text: `Are you sure to update ${this.formDetail.name}?`,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Update',
          confirmButtonColor: '#42a5ce',
          cancelButtonColor: '#D2232A',
          titleColor: '#D2232A',
        }).then(async (result) => {
          if (result.value) {
            const { name, source, form, column, isUseDigitalSignature, thirdPartyConn, attachSigned, attachNotSigned, dataset_group, dataset, table_group } = this.dataSetup;
            const dataMasterSource = this.formDetail.data_source;
            const params = this._.cloneDeep(this.formDetail);
            params.name = name;
            params.type = source.id;
            params.tablegroup_id = table_group ? table_group.id : 0;
            params.tablegroup_name = table_group ? table_group.name : '';
            params.form_data_id = source.id === 'form' ? (form ? form.id : 0) : '';
            params.form_data_name = source.id === 'form' ? (form ? form.name : '') : '';
            params.is_use_digital_signature = isUseDigitalSignature;
            params.third_party_connection_name = thirdPartyConn ? thirdPartyConn.id : null;
            params.attach_signed_document = attachSigned ? attachSigned.id : null;
            params.attach_not_signed_document = attachNotSigned ? attachNotSigned.id : null;

            let isPrimary = '';
            const dataColumn = {};
            column.forEach((element) => {
              if (element.is_primary_key) {
                isPrimary = element.name;
              }
              if (element.name) {
                const setData = {
                  name: element.name,
                  type: element.type,
                };
                dataColumn[element.name] = setData;
              }
            });
            params.data_source = {
              external_url: {
                primary_key: isPrimary,
                columns: dataColumn,
                list: dataMasterSource ? (dataMasterSource.external_url ? dataMasterSource.external_url.list : {}) : {},
                create: dataMasterSource ? (dataMasterSource.external_url ? dataMasterSource.external_url.create : {}) : {},
                update: dataMasterSource ? (dataMasterSource.external_url ? dataMasterSource.external_url.update : {}) : {},
                delete: dataMasterSource ? (dataMasterSource.external_url ? dataMasterSource.external_url.delete : {}) : {},
                detail: dataMasterSource ? (dataMasterSource.external_url ? dataMasterSource.external_url.detail : {}) : {},
                import: dataMasterSource ? (dataMasterSource.external_url ? dataMasterSource.external_url.import : {}) : {},
                export: dataMasterSource ? (dataMasterSource.external_url ? dataMasterSource.external_url.export : {}) : {},
              },
              dataset: {
                dataset_group_id: dataset_group ? dataset_group.id : '',
                dataset_group_name: dataset_group ? dataset_group.name : '',
                dataset_id: dataset ? dataset.id : '',
                dataset_name: dataset ? dataset.name : '',
              },
            };

            let res;
            if (!this.isMultipleForm) {
              res = await this.actionSetForm(params);
            } else {
              res = await this.actionSetMultiForm(params);
            }

            if (!res.error) {
              this.setChangesValueView(false);
              const dataFilter = {
                id: [this.$route.params.id],
              };
              const param = {
                limit: 0,
                page: 1,
                filter: JSON.stringify(dataFilter),
              };
              if (!this.isMultipleForm) {
                await this.actionGetDetailForm(param);
              } else {
                await this.actionGetDetailMultiForm(param);
              }
            }
          }
        });
      } else {
        this.scrollToErrorField('error-input');
      }
    },
  },

  validations() {
    const validate = {
      dataSetup: {
        name: {
          required,
        },
        source: {
          required,
        },
        form: {

        },
        external_url: {

        },
        column: {},
        thirdPartyConn: {},
        attachSigned: {},
        attachNotSigned: {},
        dataset_group: {},
        dataset: {},
      },
    };
    if (this.dataSetup.source) {
      if (this.dataSetup.source.id === 'form') {
        validate.dataSetup.table_group = { required };
        validate.dataSetup.form = { required };
      }
    }
    if (this.dataSetup.isUseDigitalSignature) {
      validate.dataSetup.thirdPartyConn = { required };
      validate.dataSetup.attachSigned = { required };
      validate.dataSetup.attachNotSigned = { required };
    }
    if (this.dataSetup.source) {
      if (this.dataSetup.source.id === 'dataset') {
        validate.dataSetup.dataset_group = { required };
        validate.dataSetup.dataset = { required };
      }
    }
    return validate;
  },
};
</script>



// WEBPACK FOOTER //
// src/views/experience-manager-v2/menu/jInformationView.vue